import { render, staticRenderFns } from "./ClosedProjectListIndex.vue?vue&type=template&id=899fe29c"
import script from "./ClosedProjectListIndex.vue?vue&type=script&lang=js"
export * from "./ClosedProjectListIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports